import React from "react";

import { StoryCard, StoryCardSimple } from "../basic/story-card.js";
import { CollectionName } from "../basic/collection-name.js";
import { DfpAd } from "../dfp-ad";
import { Link, wrapCollectionLayout } from "@quintype/components";
import PropTypes from "prop-types";

import "./two-col.m.css";

function TwoColBase({ collection, stories, config, associatedMetadata }) {
  const storyCardConfig = {
    subheadline: true,
    image: true
  };
  const imageConfig = {
    image: true,
    imageAspectRatio: [16, 9]
  };
  const { show_collection_title: collectionName = true } = associatedMetadata;

  return (
    <div styleName="component-wrapper" data-test-id="two-col-component">
      {collectionName ? <CollectionName name={collection.name} type="large" section={collection} /> : null}
      <div styleName="two-col__items">
        <div styleName="two-col__item-one">
          {stories.slice(0, 3).map(story => {
            return (
              <Link href={`/${story.slug}`} key={story.id}>
                <StoryCardSimple key={story.id} story={story} config={imageConfig} hideSectionName={true} />
              </Link>
            );
          })}
        </div>
        <div styleName="full-height-card">
          <StoryCard story={stories[3]} config={storyCardConfig} hideSectionName={true} />
        </div>
      </div>

      <div className="app-ad app-ad--horizontal">
        <DfpAd adtype="Horizontal-Ad" layoutName="TwoCol" collectionSlug={collection.slug} />
      </div>
    </div>
  );
}
TwoColBase.propTypes = {
  stories: PropTypes.arrayOf(PropTypes.object),
  config: PropTypes.object,
  collection: PropTypes.object,
  associatedMetadata: PropTypes.object
};

export const TwoCol = wrapCollectionLayout(TwoColBase);
